import type { NavigationItem } from '@/types/layout.types';
import { usePointerActivation } from '@/hooks';
import { cn } from '@/utils';

export function MobileBottomNavItem({
	item,
	icon: Icon,
	isActive,
	onNavigate,
}: {
	item: NavigationItem;
	icon: NavigationItem['icon'];
	isActive: boolean;
	onNavigate: (path: string) => void;
}) {
	const action = () => onNavigate(item.href!);
	const pointerProps = usePointerActivation(action);

	return (
		<button
			type="button"
			{...pointerProps}
			aria-current={isActive ? 'page' : undefined}
			aria-label={item.tabName}
			className="flex h-12 w-14 shrink-0 touch-manipulation flex-col items-center gap-1 px-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2667FF] focus-visible:ring-offset-2"
		>
			<Icon
				aria-hidden="true"
				className={cn(
					'h-5 w-5 transition-colors duration-200',
					isActive ? 'text-[#2667FF]' : 'text-[#414D73]'
				)}
			/>
			<span
				className={cn(
					'whitespace-nowrap text-center text-xs leading-4 tracking-[-0.144px] transition-colors duration-200',
					isActive ? 'font-medium text-[#111834]' : 'font-normal text-[#6E7899]'
				)}
			>
				{item.tabName}
			</span>
		</button>
	);
}
